import { SESSION_RECORDING_EVENTS, sendSessionRecordingEvent } from "utils/session-recording"
import fetchDependencies from "./helpers/fetch-dependencies"
import { currentUtmParams, trackCheckoutPurchase } from "./services/analytics"
import trackSignupRecordingEvent from "./session-recording"

export async function init(options = {}) {
  const { Vue, VueI18n, data } = await fetchDependencies()
  const { default: signup } = await import(/* webpackChunkName: 'sign-up' */ "./signup")
  signup(Vue, VueI18n, data, options)
}

const { FCGON } = window

function checkoutStatus() {
  const params = new URLSearchParams(window.location.search) // eslint-disable-line compat/compat
  return params.get("checkout")
}

function hasCheckoutResult() {
  const status = checkoutStatus()
  return status === "success" || status === "cancelled"
}

function trackSubscriptionFunnelEntry() {
  sendSessionRecordingEvent(SESSION_RECORDING_EVENTS.subPopupOpened)
  sendSessionRecordingEvent(
    FCGON && FCGON.logged_in
      ? SESSION_RECORDING_EVENTS.subEntryLoggedIn
      : SESSION_RECORDING_EVENTS.subEntryAnon,
  )
}

export function showSignup(options = {}) {
  if (FCGON.is_app) {
    const { callNativeApp } = window
    if (callNativeApp) {
      callNativeApp("subscribe")
      return
    }
  }
  if (!hasCheckoutResult()) trackSubscriptionFunnelEntry()
  init(options)
}

window.showSignup = showSignup

function checkoutSessionId() {
  const params = new URLSearchParams(window.location.search) // eslint-disable-line compat/compat
  return params.get("session_id")
}

const PAYMENT_SUCCESS_STORAGE_PREFIX = "session-recording-payment-success:"

function trackPaymentSuccessRecordingEvent(sessionId) {
  try {
    const key = `${PAYMENT_SUCCESS_STORAGE_PREFIX}${sessionId}`
    if (window.localStorage.getItem(key) === "1") return
    window.localStorage.setItem(key, "1")
  } catch {
    // Ignore storage failures; accept a possible duplicate event on revisits.
  }
  sendSessionRecordingEvent(SESSION_RECORDING_EVENTS.subPaymentSuccess)
}

function trackCheckoutSuccessPurchase() {
  if (checkoutStatus() !== "success") return

  const sessionId = checkoutSessionId()
  const params = currentUtmParams()
  trackCheckoutPurchase(sessionId, params)
  trackPaymentSuccessRecordingEvent(sessionId)
}

function checkoutStepOptions() {
  const status = checkoutStatus()
  if (status === "success") {
    return { initialStep: "the-finish" }
  }
  if (status === "cancelled") {
    return { initialStep: FCGON && FCGON.logged_in ? "the-plan-selection" : "the-promo-signup" }
  }

  return {}
}

function cleanCheckoutResultFromUrl() {
  if (!window.history || !window.history.replaceState) return

  const url = new URL(window.location.href) // eslint-disable-line compat/compat
  url.searchParams.delete("checkout")
  url.searchParams.delete("session_id")
  window.history.replaceState(window.history.state, document.title, url.toString())
}

function mountSubscribe(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild)
  }
  const mountNode = document.createElement("div")
  node.appendChild(mountNode)
  init({
    el: mountNode,
    ...checkoutStepOptions(),
    variant: "page",
  })
}

export default async function setListeners() {
  const subscribeNodes = Array.from(document.querySelectorAll(".js-subscribe"))
  subscribeNodes.forEach((node) => {
    mountSubscribe(node)
  })
  if (subscribeNodes.length > 0) {
    if (hasCheckoutResult()) {
      trackCheckoutSuccessPurchase()
      cleanCheckoutResultFromUrl()
    } else {
      trackSubscriptionFunnelEntry()
    }
  }

  const nodes = Array.from(document.querySelectorAll(".js-sign-up, .js-sign-up-no-free"))
  nodes.forEach((node) => {
    node.addEventListener("click", (event) => {
      event.preventDefault()
      // While a subscription is in dunning (failed renewal being retried), the
      // member must fix billing — not start a new subscription. Send any premium
      // padlock/CTA to the My membership page instead of opening the sign-up flow.
      if (FCGON && FCGON.subscription_billing_issue) {
        window.location.href = "/profile/subscription"
        return
      }
      trackSignupRecordingEvent(node)
      showSignup()
    })
  })
  // Automatic startup on the dedicated sign up page
  if (subscribeNodes.length === 0 && hasCheckoutResult()) {
    showSignup(checkoutStepOptions())
    trackCheckoutSuccessPurchase()
    cleanCheckoutResultFromUrl()
  } else if (FCGON && FCGON.sign_up_immediately) {
    trackSubscriptionFunnelEntry()
    init()
  }
}
